import { render, staticRenderFns } from "./preview-pdf.vue?vue&type=template&id=01f5aa21&"
import script from "./preview-pdf.vue?vue&type=script&lang=js&"
export * from "./preview-pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports